export default {
  "nav.home": "Accueil",
  "nav.products": "Produits",
  "nav.guide": "Guide Spreadsheet",
  "nav.categories": "Catégories",
  "nav.visitSite": "Visiter le site principal",

  "hero.badge": "Ressources mises à jour · Organisées par catégorie",
  "hero.title": "Tableur AllChinaBuy",
  "hero.subtitle": "Trouvez des produits, des vendeurs et des ressources d'achat dans le dernier tableur AllChinaBuy — le tout réuni au même endroit.",
  "hero.ctaPrimary": "tableur allchinabuy",
  "hero.ctaSecondary": "acheter maintenant",

  "dropdown.label": "Choisissez une catégorie",
  "dropdown.placeholder": "Sélectionnez une catégorie…",

  "categories.title": "Explorer les catégories de produits",
  "categories.subtitle": "Accédez directement à la catégorie recherchée sur le site principal.",

  "text.title": "Qu'est-ce que le tableur AllChinaBuy ?",
  "text.paragraph1": "Le tableur AllChinaBuy est une ressource partagée qui regroupe les liens produits, les informations sur les vendeurs et les listes de catégories dans une vue organisée. Au lieu de parcourir d'innombrables pages, utilisez-le comme point de départ pour découvrir des articles de mode, des baskets, du streetwear, des sacs et bien plus.",
  "text.paragraph2": "Ce site est un hub d'information indépendant. Nous organisons les catégories pour vous permettre de passer rapidement d'un sujet à l'autre vers le site principal, où se trouvent toutes les listes de produits.",

  "articleLink.title": "Lire le guide complet",
  "articleLink.subtitle": "Apprenez à utiliser le tableur AllChinaBuy, ce que contient chaque catégorie et comment acheter en toute sécurité.",
  "articleLink.cta": "Lire le guide",

  "footer.disclaimer": "Il s'agit d'une ressource d'information indépendante. Les liens produits s'ouvrent sur le site principal kaspreadsheet.com.",
  "footer.rights": "Hub du tableur AllChinaBuy.",

  "categories.shoes": "Chaussures",
  "categories.hoodies": "Hoodies/Sweats",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons/Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "sous-vêtements",
  "categories.jersey": "Maillots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres",

  "products.featuredTitle": "Produits en vedette",
  "products.featuredSubtitle": "Découvrez les produits populaires du AllChinaBuy spreadsheet. Cliquez pour voir et acheter sur le site principal.",
  "products.viewAll": "Voir tous les produits",

  "article.title": "Guide du tableur AllChinaBuy : produits, catégories et utilisation",
  "article.back": "Retour à l'accueil",
  "article.published": "Mis à jour",
  "article.intro": "Le tableur AllChinaBuy est l'un des moyens les plus rapides de parcourir une large gamme de produits depuis une seule ressource organisée. Dans ce guide, nous expliquons ce qu'est le tableur, comment les catégories sont organisées et comment passer d'une catégorie aux listes de produits.",
  "article.h2.what": "Qu'est-ce que le tableur AllChinaBuy ?",
  "article.p.what": "Le tableur AllChinaBuy sert de référence centrale pour les produits et les vendeurs. Il regroupe les articles en catégories claires — chaussures, hoodies, t-shirts, vestes, pantalons, couvre-chefs, ensembles, sous-vêtements, maillots, accessoires, sacs, ceintures, parfums et plus — pour trouver rapidement la section souhaitée.",
  "article.h2.categories": "Comment les catégories sont organisées",
  "article.p.categories": "Chaque catégorie de ce site renvoie directement à la section correspondante du site principal. Lorsque vous choisissez une catégorie, vous êtes dirigé vers les listes de ce groupe, ce qui rend l'expérience simple : choisissez une catégorie, ouvrez le lien et parcourez les produits.",
  "article.h2.howto": "Comment utiliser le tableur",
  "article.p.howto": "Commencez par la page d'accueil, choisissez une catégorie dans le menu déroulant ou via les boutons de catégories, et vous serez redirigé vers le site principal. Vous pourrez alors parcourir la liste, comparer les vendeurs et vérifier les détails avant de décider.",
  "article.h2.safety": "Acheter en toute sécurité",
  "article.p.safety": "Vérifiez toujours les descriptions, les évaluations des vendeurs et les détails d'expédition sur le site principal avant de commander. Gardez vos informations de paiement et de compte sécurisées et vérifiez les liens avant de cliquer.",
  "article.conclusion": "Prêt à explorer ? Revenez à la page d'accueil pour parcourir les catégories et ouvrir les listes complètes du tableur AllChinaBuy.",
  "article.cta": "Retour au tableur AllChinaBuy",
};